const Profile = () =>
  import(/* webpackChunkName: "profile" */ '../views/Profile.vue')

const ProfileRoute = [
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Profile',
      backLink: 'dashboard',
    },
  },
]

export default ProfileRoute
